import type { CounterpartyActivity } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { COUNTERPARTY_ACTIVITY_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useCounterpartyActivity(startDate: string, endDate: string, crbId?: string) {
  const { userBankId } = useUser();
  const banksApi = new BanksApi();

  const {
    data,
    isLoading: isLoadingCounterpartyActivity,
    isFetching: isFetchingCounterpartyActivity
  } = useQuery<CounterpartyActivity[]>({
    enabled: !!userBankId && !!startDate && !!endDate,
    queryKey: [COUNTERPARTY_ACTIVITY_KEY, userBankId, startDate, endDate, crbId],
    queryFn: async () => {
      return await banksApi.getCounterpartyActivity(userBankId, startDate, endDate, crbId);
    },
    meta: {
      snackbarErrorMessage:
        'There was an issue loading counterparty activity. Please try again, or contact support if the problem persists.'
    }
  });

  return { counterpartyActivity: data, isLoadingCounterpartyActivity, isFetchingCounterpartyActivity };
}
